// TODO: remove it
export enum MakeTransferFormField {
  TO = 'to',
  FROM = 'from',
  AMOUNT = 'amount',
  PAYMENT_OPTION = 'paymentOption',
  TRANSFER_TYPE = 'transferType',
  DELIVERY_METHOD = 'deliveryMethod',
  SCHEDULED_DATE = 'scheduledDate',
  RECURRING_START_DATE = 'recurringStartDate',
  RECURRING_START_DATE_1 = 'recurringStartDate1',
  RECURRING_START_DATE_2 = 'recurringStartDate2',
  RECURRING_TYPE = 'recurringType',
  RECURRING_NUMBER = 'recurringNumber',
  RECURRING_END_DATE = 'recurringEndDate',
  MEMO = 'memo',
  FEE = 'fee',
  ACCOUNT_NUMBER = 'accountNumber',
  PRIMARY_NAME = 'primaryName',
  ROUTING_NUMBER = 'routingNumber',
  ACCOUNT_TYPE = 'accountType',
  BANK_NAME_SHORT = 'shortBankName',
  BANK_NAME_FULL = 'fullBankName',
  AGREEMENT_ACCEPTED = 'agreementAccepted',
  SETTLEMENT_DATE = 'settlementDate',
}
